<template>
  <div>
    <b-btn
        v-bind="$attrs"
        @click="showModal"
        :disabled="isLoading"
        :variant="isLoading ? 'primary' : 'info'"
    >
      <template v-if="isLoading">
        Идет актуализация...
      </template>
      <template v-else>
        <slot>Актуализировать</slot>
      </template>
    </b-btn>

    <ModalWrapper
        title="Вы уверены, что хотите актуализировать данные?"
        name="ConfirmActualization"
        @submit="confirmAndSubmit"
        @close-modal="closeModal"
        v-model="showActualizeModal"
    />

    <!-- дата актуализации показывается только если её передали:
         раньше подпись висела всегда и без значения -->
    <div v-if="date" class="actualize-date">
      Актуализировано: {{ date }}
    </div>
  </div>
</template>

<script>
import ModalWrapper from "@/components/modals/index.vue";

export default {
  inheritAttrs: false,
  components: {
    ModalWrapper,
  },
  props: {
    actualizeFunction: {
      type: Function,
      required: true,
    },
    date: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      showActualizeModal: false, // Контроль состояния модального окна
    };
  },
  methods: {
    // Открытие модального окна
    showModal() {
      this.showActualizeModal = true;
    },

    // Закрытие модального окна
    closeModal() {
      this.showActualizeModal = false;
    },

    // Подтверждение и выполнение функции
    async confirmAndSubmit() {
      try {
        this.isLoading = true;
        this.closeModal(); // Закрываем модальное окно

        await this.actualizeFunction(); // Выполняем функцию из пропса

        // Показываем успех через BootstrapVue toast
        this.$bvToast.toast('Актуализация успешно завершена!', {
          title: 'Успех',
          variant: 'success',
          autoHideDelay: 2000,
          solid: true
        });
      } catch (error) {
        console.error("Ошибка при выполнении функции актуализации:", error);
        // Можно при желании добавить уведомление об ошибке
        this.$bvToast.toast('Что-то пошло не так', {
          title: 'Ошибка',
          variant: 'danger',
          autoHideDelay: 2000,
          solid: true
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form-tokens";

.actualize-date {
  @include tf-tokens-light;

  margin-top: 6px;
  font-size: 11.5px;
  color: var(--tf-muted);
}

body.dark-only .actualize-date {
  @include tf-tokens-dark;
}
</style>
